export { ConsumptionView } from "../../components/consumption/consumption-view";
